import React from 'react';

const Features = () => {
  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Tính năng chính</h2>
          <p className="section-description">
            Những tính năng cốt lõi được thiết kế đơn giản và thực tế cho dự án simHUD
          </p>
        </div>
        <div className="features-grid">
          <div className="feature-card glass">
            <span className="material-icons">developer_board</span>
            <h3>ESP32 Integration</h3>
            <p>Kết nối trực tiếp với ESP32 để nhận dữ liệu real-time từ các cảm biến</p>
          </div>
          <div className="feature-card glass">
            <span className="material-icons">dashboard</span>
            <h3>HUD Display</h3>
            <p>Giao diện HUD tối giản, hiển thị thông tin quan trọng một cách trực quan</p>
          </div>
          <div className="feature-card glass">
            <span className="material-icons">cloud_download</span>
            <h3>OTA Updates</h3>
            <p>Cập nhật firmware Over-The-Air qua WiFi, tiện lợi và linh hoạt cho phát triển lâu dài</p>
          </div>
          <div className="feature-card glass">
            <span className="material-icons">design_services</span>
            <h3>Thiết kế đơn giản</h3>
            <p>Giao diện tối giản, dễ sử dụng và dễ phát triển thêm tính năng mới</p>
          </div>
          <div className="feature-card glass">
            <span className="material-icons">update</span>
            <h3>Giao diện mượt mà</h3>
            <p>Hiển thị dữ liệu smooth với animation tự nhiên, không lag hay giật</p>
          </div>
          <div className="feature-card glass">
            <span className="material-icons">tune</span>
            <h3>Customizable</h3>
            <p>Tùy chỉnh giao diện và cấu hình theo nhu cầu sử dụng cá nhân</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
